/**
 * V2 app settings — banner_message and is_read_only from the same
 * app_settings row V1 and the admin panel use. Loaded once at startup
 * into store slices; read-only gates create/edit/delete UI.
 */
import * as gateway from './gateway.js';
import { cached } from './query.js';

export async function loadAppSettings(store) {
  try {
    const settings = await cached('app-settings', async () => {
      const { data, error } = await gateway.rawQuery(gateway.TABLES.APP_SETTINGS, {
        select: '*',
        limit: 1,
      });
      if (error) throw error;
      return data?.[0] || null;
    }, { ttl: 5 * 60_000 });
    store.set({
      isReadOnly: Boolean(settings?.is_read_only),
      bannerMessage: settings?.banner_message || null,
    });
  } catch {
    // Settings are decoration/guard rails — the app runs without them
  }
}

export function isReadOnly(store) {
  return Boolean(store.get().isReadOnly);
}

export const READ_ONLY_MESSAGE =
  'The journal is read-only right now for maintenance — browsing works, changes will be back shortly.';
